import {format} from 'url';
import {SET_LISTINGS} from './action-types';
import {getPrefix} from '../utils/urls';

export const UNREFINED_KEY = 'unrefined';

export const setListings = (listings, refinementKey) => {
    return {
        type: SET_LISTINGS,
        ...listings,
        refinementKey
    };
};

export const fetchListings = (lbsId, site, count, refinementKey = '') => {
    return (dispatch) => {
        const query = {
            id: lbsId,
            site,
            count
        };

        if (refinementKey && refinementKey !== UNREFINED_KEY) {
            query.refinementKey = refinementKey;
        }

        const requestUrl = format({
            pathname: `/${getPrefix()}/api/listings`,
            query
        });

        return fetch(requestUrl)
            .then((res) => {
                if (!res.ok) {
                    throw new Error(
                        'Failed loading listings'
                    );
                }
                return res.json();
            })
            .then((listings) =>
                dispatch(setListings(listings, refinementKey))
            )
            .catch((err) => console.log(err));  // eslint-disable-line
    };
};
